<script>
    import { onMount, createEventDispatcher } from 'svelte'
    import FrequencySelector from './FrequencySelector.svelte'

    export let data = null

    let minutes     = [],
        hours       = [],
        months      = [],

        monthsNames = [
            "Gen",
            "Feb",
            "Mar",
            "Apr",
            "Mag",
            "Giu",
            "Lug",
            "Ago",
            "Set",
            "Ott",
            "Nov",
            "Dic"
        ],

        typeVal     = 'once',
        minuteVal   = '0',
        hoursVal    = '8',
        daysVal     = '1',
        monthsVal   = '*',
        dowVal      = '*',

        types       = [
            {
                id: 'once',
                text: 'Una volta',
                reset: true
            },
            {
                id: 'weekly',
                text: 'Settimanale',
                reset: true
            },
            {
                id: 'biweekly',
                text: 'Bi-settimanale',
                reset: true
            },
            {
                id: 'daily',
                text: 'Giornaliero',
                reset: true
            }
        ],
        daysOfWeekAll = [
            {
                id: '1',
                text: 'Lunedì'
            },
            {
                id: '2',
                text: 'Martedì'
            },
            {
                id: '3',
                text: 'Mercoledì'
            },
            {
                id: '4',
                text: 'Giovedì'
            },
            {
                id: '5',
                text: 'Venerdì'
            },
            {
                id: '6',
                text: 'Sabato'
            },
            {
                id: '0',
                text: 'Domenica'
            }
        ],
        daysOfWeekOpt = [
            {
                id: '1',
                text: 'Lunedì',
                reset: true
            },
            {
                id: '2',
                text: 'Martedì',
                reset: true
            },
            {
                id: '3',
                text: 'Mercoledì',
                reset: true
            },
            {
                id: '4',
                text: 'Giovedì',
                reset: true
            },
            {
                id: '5',
                text: 'Venerdì',
                reset: true
            },
            {
                id: '6',
                text: 'Sabato',
                reset: true
            },
            {
                id: '0',
                text: 'Domenica',
                reset: true
            }
        ],
        daysOfWeek = daysOfWeekOpt,

        cronstring = null,
        cronvalues = [],
        cronmonths = []
    

    /*
    # ┌───────────── minute (0 - 59)
    # │ ┌───────────── hour (0 - 23)
    # │ │ ┌───────────── day of the month (1 - 31)
    # │ │ │ ┌───────────── month (1 - 12)
    # │ │ │ │ ┌───────────── day of the week (0 - 6) (Sunday to Saturday;
    # │ │ │ │ │                                   7 is also Sunday on some systems)
    # │ │ │ │ │
    # │ │ │ │ │
    # * * * * * <command to execute>
    */

        
    const dispatch = createEventDispatcher ();

    const bootstrap = () => {
        minutes.push ({
            id: "0",
            text: "--"
        });
        hours.push ({
            id: "8",
            text: "--"
        });
        months.push ({
            id: "*",
            text: "Tutti i mesi",
            reset: true
        });

        for (var j = 0; j < 60; j++) {
            minutes.push ({
                id: j.toString(),
                text: j
            })
        }
        for (var j = 0; j < 24; j++) {
            hours.push ({
                id: j.toString(),
                text: j
            })
        }
        for (var j = 1; j < 13; j++) {
            months.push ({
                id: j.toString(),
                text: monthsNames[j - 1]
            })
        }
        minutes = minutes
        hours = hours
        months = months
    }

    const onTypeChange = (event) => {
        typeVal = event.detail;

        if (typeVal === 'once') {
            daysVal = '1'
            dowVal = '*'
        }

        else if (typeVal === 'daily') {
            daysVal = '*'
            dowVal = '0,1,2,3,4,5,6'
            daysOfWeek = daysOfWeekAll
        }

        else if (typeVal === 'weekly') {
            daysVal = '*'
            dowVal = '1'
            daysOfWeek = daysOfWeekOpt
        }

        else if (typeVal === 'biweekly') {
            daysVal = '1,15'
            dowVal = '*'
            daysOfWeek = daysOfWeekOpt
        }
    }

    const onMonthSelect = (event) => {
        monthsVal = event.detail
    }

    const onDowChange = (event) => {
        dowVal = event.detail
    }

    const loadCronstring = (cronstring) => {
        const cronvalues = cronstring.trim().split (' ');

        if (cronvalues) {
            // console.log ('loadCronstring', cronstring, cronvalues)
            if (cronvalues[0] !== undefined && cronvalues[0] !== '')
                minuteVal = cronvalues[0];
            if (cronvalues[1] !== undefined && cronvalues[1] !== '')
                hoursVal = cronvalues[1];
            if (cronvalues[2] !== undefined)
                daysVal = cronvalues[2];
            if (cronvalues[3] !== undefined)
                monthsVal = cronvalues[3];
            if (cronvalues[4] !== undefined)
                dowVal = cronvalues[4];

            
            // Guessing type ...
            if (cronvalues[2] === '1') {
                typeVal = 'once'
            } else if (cronvalues[2] === '*' && (cronvalues[4] === '*' || cronvalues[4].length > 1)) {
                typeVal = 'daily'
                daysOfWeek = daysOfWeekAll
            } else if (cronvalues[2] === '*' && cronvalues[4] !== '*') {
                typeVal = 'weekly'
                daysOfWeek = daysOfWeekOpt
            } else if (cronvalues[2] === '1,15') {
                typeVal = 'biweekly'
                daysOfWeek = daysOfWeekOpt
            }
        }
    }

    const updateState = (m, h, d, M, D) => {
        cronstring = `${m} ${h} ${d} ${M} ${D}`
        cronvalues = [ m, h, d, M, D ]

        if (M === '*') {
            cronmonths = [1,2,3,4,5,6,7,8,9,10,11,12]
        } else {
            cronmonths = M.split (',').map (it => parseInt (it))
        }
        
        console.log ('cron changed', cronstring)

        setTimeout (() => {
            dispatch ('select', {
                cron: cronstring,
                values: cronvalues,
                months: cronmonths
            })
        }, 50)
    }

    onMount (bootstrap)
    
    $: {
        loadCronstring (data)
    }

    $: {
        updateState (minuteVal, hoursVal, daysVal, monthsVal, dowVal)
    }
</script>

<style>
    .CronEditor .field {
        margin-bottom: 10px;
    }
    .CronEditor .field .lbl {
        display: inline-block;
        margin-right: 10px;
        min-width: 80px;
        font-weight: 600;
    }
    .CronEditor .field .lbl-s {
        display: inline-block;
        margin: 0 5px;
        font-weight: 600;
    }
    .CronEditor .field select {
        display: inline-block;
        padding: 0px 10px;
        background-color: transparent;
        border: 0;
        outline: 0;
        font-size: 14px;
        color: #586d7d;
        background-color: #dbe4ea;
        -webkit-appearance: none;
        border-radius: 2px;
    }
</style>

<div class="CronEditor">
    <!-- <div>{cronstring}</div> -->
    <div class="field">
        <div class="lbl">Mese/i</div>
        <FrequencySelector items={months} value={monthsVal} on:select={onMonthSelect} />
    </div>
    <div class="field">
        <div class="lbl">Tipo</div>
        <FrequencySelector items={types} value={typeVal} on:select={onTypeChange} />
    </div>
    {#if typeVal === 'weekly' || typeVal === 'daily'}
        <div class="field">
            <div class="lbl-s">Giorno della Settimana</div>
            <FrequencySelector items={daysOfWeek} value={dowVal} on:select={onDowChange} />
        </div>
    {/if}
    <div class="field">
        <div class="lbl">Ora</div>
        <div>
            <select bind:value={hoursVal}>
                {#each hours as hour}
                    <option value={hour.id}>{hour.text}</option>
                {/each}
            </select>
            <select bind:value={minuteVal}>
                {#each minutes as min}
                    <option value={min.id}>{min.text}</option>
                {/each}
            </select>
        </div>
    </div>
</div>